import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { clearAppState, saveAbbreviations, saveApplicationWiseCapabilities, saveCustomerConfig, saveEnvironments, saveLoginOrigin } from './app.actions';

export interface appState {
    loginOrigin: string | null;
    customerConfig: any | null;
    applicationWiseCapabilities: any | null;
    environments: any | null;
    abbreviations: any | null;
}

export const initialState: appState = {
    loginOrigin: null,
    customerConfig: null,
    applicationWiseCapabilities: null,
    environments: null,
    abbreviations: null,
};

export const appFeature = createFeature({
    name: 'app',
    reducer: createReducer(
        initialState,
        on(saveLoginOrigin, (state, { origin }) => ({ ...state, loginOrigin: origin })),
        on(clearAppState, () => ({ ...initialState })),
        on(saveCustomerConfig, (state, { config }) => ({ ...state, customerConfig: config })),
        on(saveEnvironments, (state, { environments }) => ({ ...state, environments: environments })),
        on(saveAbbreviations, (state, { abbreviations }) => ({ ...state, abbreviations: abbreviations })),
        on(saveApplicationWiseCapabilities, (state, { applicationId, capabilities }) => ({ ...state, applicationWiseCapabilities: { ...state.applicationWiseCapabilities, [applicationId]: capabilities } })),
    ),
});

export const { name, reducer, selectAppState } = appFeature;
export const selectLoginOrigin = createSelector(selectAppState, (state) => state.loginOrigin);
export const selectCustomerConfig = createSelector(selectAppState, (state) => state.customerConfig);
export const selectApplicationWiseCapabilities = createSelector(selectAppState, (state) => state.applicationWiseCapabilities);
export const selectEnvironments = createSelector(selectAppState, (state) => state.environments);
export const selectAbbreviations = createSelector(selectAppState, (state) => state.abbreviations);